import { useState, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';

import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

export default function LoginButton() {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);

  const handleLogin = useCallback(async () => {
    try {
      setLoading(true);
      await instance.loginPopup();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [instance]);

  return (
    <LoadingButton
      fullWidth
      color="inherit"
      size="large"
      type="submit"
      variant="contained"
      onClick={handleLogin}
      loading={loading}
      sx={{
        bgcolor: 'text.primary',
        color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
        '&:hover': {
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
        },
      }}
    >
      Login
    </LoadingButton>
  );
}